module.exports = __webpack_public_path__ + "img/tranquilo_lg.fabc59a8.jpg";